import React from 'react';

// --- Début des Icônes SVG ---

// Icône SVG pour "Recherche" (Search)
const SearchIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <circle cx="11" cy="11" r="8"></circle>
    <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
  </svg>
);

// Icône SVG pour "Presse-papiers" (ClipboardList)
const ClipboardListIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <rect x="8" y="2" width="8" height="4" rx="1" ry="1"></rect>
    <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path>
    <line x1="12" y1="11" x2="12" y2="17"></line>
    <line x1="9" y1="14" x2="15" y2="14"></line>
  </svg>
);

// Icône SVG pour "Spray"
const SprayCanIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="m10 4 1.4-1.4a.5.5 0 0 1 .7 0L14 4"></path>
    <path d="M12 4v3"></path>
    <path d="M18 4h-2"></path>
    <path d="M6 4h2"></path>
    <path d="M12 7h.01"></path>
    <path d="M15 10v6a3 3 0 0 1-3 3h0a3 3 0 0 1-3-3v-6a3 3 0 0 1 3-3h0a3 3 0 0 1 3 3Z"></path>
    <path d="M9 10v6"></path>
    <path d="M15 10v6"></path>
    <path d="M10 21h4"></path>
  </svg>
);

// Icône SVG pour "Check Cercle" (CheckCircle)
const CheckCircleIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
    <polyline points="22 4 12 14.01 9 11.01"></polyline>
  </svg>
);


const processSteps = [
  {
    step: 1,
    title: 'Diagnostic',
    icon: SearchIcon, // Remplacé
    description: 'Inspection et analyse complète de la situation.',
    details: [
      'Inspection complète des lieux',
      'Identification précise du nuisible',
      'Évaluation du niveau d\'infestation',
      'Analyse des points d\'accès et des causes'
    ],
    color: 'bg-blue-500'
  },
  {
    step: 2,
    title: 'Plan d\'Action',
    icon: ClipboardListIcon, // Remplacé
    description: 'Proposition d\'une solution sur mesure.',
    details: [
      'Choix de la méthode de traitement',
      'Présentation des produits certifiés',
      'Devis détaillé et transparent',
      'Planification de l\'intervention'
    ],
    color: 'bg-green-500'
  },
  {
    step: 3,
    title: 'Traitement',
    icon: SprayCanIcon, // Remplacé
    description: 'Intervention rapide, discrète et sécurisée.',
    details: [
      'Intervention par des techniciens formés',
      'Application sécurisée des produits',
      'Respect des normes de sécurité',
      'Intervention respectueuse de l\'environnement'
    ],
    color: 'bg-primary' // Votre couleur principale
  },
  {
    step: 4,
    title: 'Suivi & Prévention',
    icon: CheckCircleIcon, // Remplacé
    description: 'Contrôle et conseils post-intervention.',
    details: [
      'Contrôle d\'efficacité post-traitement',
      'Remise d\'une attestation d\'intervention',
      'Conseils de prévention personnalisés',
      'Mise en place de contrats de suivi (optionnel)'
    ],
    color: 'bg-slate-blue'
  }
];

export function ProcessSection() {
  return (
    <section id="methode" className="py-20 bg-background">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* En-tête de section - Mis à jour */}
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-foreground mb-4">
            Notre Méthode d'Intervention
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Du diagnostic initial au suivi post-intervention, notre approche systématique 
            garantit une solution efficace, durable et adaptée à vos besoins.
          </p>
        </div>

        {/* Étapes du processus - Bureau (Desktop) */}
        <div className="hidden md:block relative mb-16">
          {/* Ligne de connexion */}
          <div className="absolute top-16 left-0 right-0 h-0.5 bg-gradient-to-r from-blue-500 via-green-500 via-primary to-slate-blue"></div>
          
          {/* Étapes */}
          <div className="grid grid-cols-4 gap-8">
            {processSteps.map((step, index) => {
              const IconComponent = step.icon; // Sera SearchIcon, etc.
              return (
                <div
                  key={step.step}
                  className="relative text-center"
                  style={{ animationDelay: `${index * 0.2}s` }}
                >
                  {/* Cercle avec numéro */}
                  <div className={`w-16 h-16 ${step.color} rounded-full flex items-center justify-center mx-auto mb-4 relative z-10 shadow-lg`}>
                    <span className="text-white font-bold text-xl">{step.step}</span>
                  </div>

                  {/* Icône */}
                  <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center mx-auto mb-4 shadow-md border-2 border-gray-100">
                    <IconComponent className="w-6 h-6 text-gray-600" />
                  </div>

                  {/* Contenu */}
                  <h3 className="text-xl font-semibold mb-2 text-foreground">{step.title}</h3>
                  <p className="text-muted-foreground text-sm mb-4">{step.description}</p>
                </div>
              );
            })}
          </div>
        </div>

        {/* Étapes du processus - Mobile - Remplacé <Card> par <div> */}
        <div className="md:hidden space-y-8 mb-16">
          {processSteps.map((step, index) => {
            const IconComponent = step.icon;
            return (
              // Remplacé <Card> par <div>
              <div
                key={step.step}
                className="border-0 shadow-lg rounded-lg" // Ajout de rounded-lg
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                {/* Remplacé <CardContent> par <div> */}
                <div className="p-6">
                  <div className="flex items-start space-x-4">
                    <div className={`w-12 h-12 ${step.color} rounded-full flex items-center justify-center flex-shrink-0`}>
                      <span className="text-white font-bold">{step.step}</span>
                    </div>
                    <div className="flex-1">
                      <div className="flex items-center space-x-2 mb-2">
                        <IconComponent className="w-5 h-5 text-gray-600" />
                        <h3 className="text-lg font-semibold text-foreground">{step.title}</h3>
                      </div>
                      <p className="text-muted-foreground text-sm mb-3">{step.description}</p>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Détails des étapes (la grille de cartes) - Remplacé <Card> par <div> */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {processSteps.map((step, index) => {
            const IconComponent = step.icon;
            return (
              // Remplacé <Card> par <div>
              <div
                key={step.step}
                className="group hover:shadow-xl transition-all duration-300 border-0 bg-white hover:-translate-y-2 rounded-lg" // Ajout de rounded-lg
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                {/* Remplacé <CardContent> par <div> */}
                <div className="p-6">
                  <div className="flex items-center space-x-3 mb-4">
                    <div className={`w-10 h-10 ${step.color} rounded-lg flex items-center justify-center`}>
                      <IconComponent className="w-5 h-5 text-white" />
                    </div>
                    <h3 className="text-lg font-semibold text-foreground">{step.title}</h3>
                  </div>

                  <ul className="space-y-2">
                    {step.details.map((detail, detailIndex) => (
                      <li key={detailIndex} className="text-sm text-muted-foreground flex items-start">
                        <div className="w-1.5 h-1.5 bg-primary rounded-full mt-2 mr-2 flex-shrink-0"></div>
                        <span>{detail}</span>
                      </li>
                    ))}
                  </ul>

                  {/* Badge avec numéro */}
                  <div className="flex justify-end mt-4">
                    <div className={`w-8 h-8 ${step.color} rounded-full flex items-center justify-center opacity-20 group-hover:opacity-100 transition-opacity`}>
                      <span className="text-white font-bold text-sm">{step.step}</span>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        
        {/* CTA - C'est déjà un <button> HTML */}
        <div className="text-center mt-16">
          <div className="bg-gradient-to-r from-slate-blue/5 to-primary/5 rounded-lg p-8">
            <h3 className="text-xl font-semibold mb-4 text-foreground">
              Prêt à démarrer votre plan de protection ?
            </h3>
            <p className="text-muted-foreground mb-6 max-w-2xl mx-auto">
              Faites confiance à nos experts pour une intervention rapide et professionnelle. 
              Contactez-nous pour un diagnostic gratuit.
            </p>
            <button
              className="bg-primary hover:bg-primary/90 text-white px-8 py-3 rounded-lg font-semibold transition-colors"
              onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
            >
              Obtenir un Diagnostic Gratuit
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}